import { useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { CATEGORIES } from "../data/products";

export const Categories = () => {
  const trackRef = useRef(null);
  const [drag, setDrag] = useState({ active: false, startX: 0, scroll: 0 });

  const onDown = (e) => {
    setDrag({
      active: true,
      startX: e.pageX - trackRef.current.offsetLeft,
      scroll: trackRef.current.scrollLeft,
    });
  };
  const onMove = (e) => {
    if (!drag.active) return;
    e.preventDefault();
    const x = e.pageX - trackRef.current.offsetLeft;
    trackRef.current.scrollLeft = drag.scroll - (x - drag.startX);
  };
  const stop = () => setDrag((d) => ({ ...d, active: false }));

  return (
    <section id="categories" data-testid="categories-section" className="bg-brand-bg py-24 border-t border-brand-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-xl">
            <span className="text-sm uppercase tracking-[0.25em] text-[#8DC63F]">
              Browse by Category
            </span>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-text">
              A solution for every room
            </h2>
          </div>
          <span className="text-xs uppercase tracking-[0.2em] text-brand-muted2">
            ← Drag to explore →
          </span>
        </div>
      </div>

      <div
        ref={trackRef}
        data-testid="categories-track"
        onMouseDown={onDown}
        onMouseMove={onMove}
        onMouseUp={stop}
        onMouseLeave={stop}
        className={`mt-12 flex gap-6 overflow-x-auto px-6 lg:px-12 pb-4 snap-x scrollbar-hide ${
          drag.active ? "cursor-grabbing" : "cursor-grab"
        }`}
        style={{ scrollbarWidth: "none" }}
      >
        {CATEGORIES.map((c) => (
          <div
            key={c.id}
            data-testid={`category-card-${c.id}`}
            className="group relative h-[420px] w-[300px] shrink-0 snap-start overflow-hidden rounded-3xl border border-brand-border"
          >
            <img
              src={c.image}
              alt={c.name}
              draggable={false}
              className="h-full w-full object-cover bg-white transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050A15] via-[#050A15]/50 to-[#050A15]/10" />
            <div className="absolute inset-x-0 bottom-0 p-7">
              <h3 className="font-heading text-2xl font-semibold text-white">{c.name}</h3>
              <p className="mt-2 text-sm text-slate-300">{c.blurb}</p>
              <a
                href="#products"
                className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#8DC63F]"
              >
                View products <ArrowRight size={16} />
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
